import { SeniorManagerReportPreviewRecipient } from "app/containers/WeeklyCheckInMonitor/types";
import {
  useGetSeniorManagerSettingsQuery,
  useGetSeniorManagerPreviewQuery,
  useUpdateSeniorManagerSettingsMutation,
} from "./weeklyCheckInReportSettingsApi";
import ReportPreviewDrawer from "./ReportPreviewDrawer";

interface SeniorManagerReportPreviewDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onEditSettings?: () => void;
}

const renderSubtitle = (recipient: SeniorManagerReportPreviewRecipient) => (
  <>
    {recipient.jobTitle ?? ""}
    {recipient.spanSize > 0 && ` · ${recipient.spanSize} span`}
    {recipient.percentInvited > 0 && ` · ${recipient.percentInvited}%`}
  </>
);

export default function SeniorManagerReportPreviewDrawer({
  isOpen,
  onClose,
  onEditSettings,
}: Readonly<SeniorManagerReportPreviewDrawerProps>) {
  const { data: preview, isLoading } = useGetSeniorManagerPreviewQuery();
  const { data: settings } = useGetSeniorManagerSettingsQuery();
  const [updateSettings, { isLoading: isSaving }] =
    useUpdateSeniorManagerSettingsMutation();

  return (
    <ReportPreviewDrawer
      isOpen={isOpen}
      onClose={onClose}
      reportName="Senior Manager Check-in Report"
      preview={preview}
      settings={settings}
      isLoading={isLoading}
      isSaving={isSaving}
      updateSettings={updateSettings}
      renderRecipientSubtitle={renderSubtitle}
      recipientRoleLabel="Senior Manager"
      coverageSubject={{
        group: "people in their span of control",
        member: "person in their span of control",
      }}
      onEditSettings={onEditSettings}
    />
  );
}
